// Chapter and world constants shared by the lab's React layer and its engine. No three.js
// here: the main bundle imports this, while the engine (and three) load on demand.
export const CHAPTER_COUNT = 6;
export const LAST_CHAPTER = CHAPTER_COUNT - 1;

// The four worlds you can dive into, by service slug → chapter
export const WORLDS = { salesforce: 1, erp: 2, consultancy: 3, 'ai-agents': 4 };
